// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Y-z11","brief":"styles_brief__C4HbD","contacts":"styles_contacts__HGMZ7","reach-me":"styles_reach-me__ApfEi"};